import { lazy, Suspense } from 'react';
import type { TourId } from '@/hooks/use-onboarding';

// Lazy load the actual OnboardingTour to avoid loading react-joyride on initial page load
const LazyOnboardingTour = lazy(() =>
  import('./OnboardingTour').then((m) => ({ default: m.OnboardingTour })),
);

// Wrapper that handles Suspense - renders nothing while loading (tour is non-essential)
export function OnboardingTour({ tourId }: { tourId: TourId }) {
  return (
    <Suspense fallback={null}>
      <LazyOnboardingTour tourId={tourId} />
    </Suspense>
  );
}
